import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { CreateOrganizationsForm } from '@/features/organizations/create-organizations/components/create-org-form'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CreateOrganizationDialog({ open, onOpenChange }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onOpenChange={(state) => {
        onOpenChange(state)
      }}
    >
      <DialogContent className='sm:max-w-md'>
        <DialogHeader className='text-left'>
          <DialogTitle className='flex items-center gap-2'>
            {t(tokens.platform.teams.organization.start.title)} 
          </DialogTitle>
          <DialogDescription>
            {t(tokens.platform.teams.organization.start.description)}
          </DialogDescription>
        </DialogHeader>
        <CreateOrganizationsForm />
      </DialogContent>
    </Dialog>
  )
}
